var data = {
  "body": "<g fill=\"none\"><path d=\"M7.5 15V7m0 .5v3m0-3a4 4 0 0 0-4-4h-3v3a4 4 0 0 0 4 4h3m0-3h3a4 4 0 0 0 4-4v-3h-3a4 4 0 0 0-4 4v3zm0 0l4-4m-4 7l-4-4\" stroke=\"currentColor\"/></g>",
  "width": 15,
  "height": 15
};
exports.__esModule = true;
exports.default = data;